import React, { useEffect, useRef, useState } from "react";
import "./App.css";
import { Analyse, Landing, Explore, Learn, Review, Puzzles, Footer, Contact, About, NotFound, ThreatAnalysis, Openings, UserProfile } from "./Containers";
import PrivacyPolicy from "./Containers/PrivacyPolicy";
import TermsOfUse from "./Containers/TermsOfUse";
import CookiePolicy from "./Containers/CookiePolicy";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Components/Login";
import Register from "./Components/Register";
import ResetPassword from "./Components/ResetPassword";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Alert from "./Components/Alert";
import ConfirmPhone from "./Components/ConfirmPhone";
import { AnimatedModal, Hero, Nav, Timeline } from "./Components";
import { Features, Settings } from "./Containers";
import { FeaturesImage } from "./assets";
import Pricing from "./Containers/Pricing";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { main_server } from "./constants";

const firebaseConfig = {
  apiKey: "AIzaSyBAPvzX04NHpNgP-fscaFeAZoiLSnZlryQ",
  authDomain: "chess-mind.firebaseapp.com",
  projectId: "chess-mind",
  storageBucket: "chess-mind.firebasestorage.app",
  messagingSenderId: "970269049766",
  appId: "1:970269049766:web:dfbf2f9df4c686100f4567",
  measurementId: "G-7V9VK55C67"
}; 

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

function App() {
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [alertText, setAlertText] = useState("");
  const [alertType, setAlertType] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [dark, setDark] = useState(false);
  const [selected, setSelected] = useState(0);
  const [logged, setLogged] = useState(false);

  const [plan, setPlan] = useState(4);
  const [coin, setCoin] = useState(0);
  const [time, setTime] = useState({});
  const [yearly, setYearly] = useState(false);
  const [date, setDate] = useState(null);
  const [showNav, setShowNav] = useState(true);

  const discountRef = useRef<HTMLButtonElement>(null);


  async function getUserData() {
    const token = localStorage.getItem("chesscloud-token");
    if (token === null || token === undefined || typeof(token) !== 'string' || token.length < 10) return;
    const response = await fetch(
      main_server + "user",
      {
        method: "GET",
        headers: {
          "Content-Type": "text/plain",
           Authorization: "Bearer " + token,
        },
      },
    );
    if (response.status === 200) {
      try {
        const data = await response.json();
        if (data === null || data === undefined) {
          setLogged(false);
          window.location.pathname.length > 1 && window.location.pathname !== '/about' && window.location.pathname !== '/contact' && window.location.pathname !== '/pricing' && (window.location.href = '/login?redirect=' + window.location.pathname);
        } else {
          setLogged(true);
          setPlan(data.plan);
          setCoin(data.coin ?? 0);
          setYearly(data.yearly ?? false);
          setDate(data.date ?? new Date());
          const dataDate = new Date(data.time.date);
          const currentDate = new Date();
          const sameDay = dataDate.getFullYear() === currentDate.getFullYear() &&
          dataDate.getMonth() === currentDate.getMonth() &&
          dataDate.getDate() === currentDate.getDate();
          setTime(sameDay ? data.time.val : 0);
          if (data.popup) {
            discountRef.current?.click();
          }
        }
      } catch (e) {
        setLogged(false);
        window.location.pathname.length > 1 && window.location.pathname !== '/about' && window.location.pathname !== '/contact' && window.location.pathname !== '/pricing' && (window.location.href = '/login?redirect=' + window.location.pathname);
      }
    } else {
      setLogged(false);
      window.location.pathname.length > 1 && window.location.pathname !== '/about' && window.location.pathname !== '/contact' && window.location.pathname !== '/pricing' && (window.location.href = '/login?redirect=' + window.location.pathname);
    }
  }

  useEffect(() => {
    !logged && !window.location.href.includes('/profile') && !window.location.href.includes('/login') && !window.location.href.includes('/register') && !window.location.href.includes('/reset-password') && (window.location.href.includes('/confirm') ? window.location.href.includes('/confirm?mode=phone') : true) && getUserData();
    var cookie = null;
    try {
      cookie = document.cookie.split('chesscloud-token=')[1];
      cookie.includes(';') && (cookie = cookie.split(';')[0]);
    } catch (e) {

    }
    if (cookie === null || cookie === undefined) {
      const storedToken = localStorage.getItem('chesscloud-token');
      document.cookie = `chesscloud-token=${storedToken}; domain=.chessmind.io; path=/; max-age=31536000`;
    }
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
    let resizeWindow = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener("resize", resizeWindow);
    const theme = localStorage.getItem('chesscloud_theme');
    if (theme === '0') setDark(true);
    return () => window.removeEventListener("resize", resizeWindow);
  }, []);

  const [scrollPos, setScrollPos] = useState(0);
  const [scrolledUp, setScrolledUp] = useState(false);
  const [isPuzzleDropdownOpen, setIsPuzzleDropdownOpen] = useState(false);
  const [isPlayDropdownOpen, setIsPlayDropdownOpen] = useState(false);

  const handleScroll = () => {
      const position = window.scrollY;
      if (scrollPos > position) {
        setScrolledUp(true);
      } else {
        setScrolledUp(false);
      }
      setScrollPos(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, [scrollPos]);

  return (
    <GoogleOAuthProvider clientId="211737371497-tbthl1kq8prgp0mq9c0otqbdo65prngo.apps.googleusercontent.com">
      <div className={`mainContainer w-full h-full`}>
        <Nav isPuzzleDropdownOpen={isPuzzleDropdownOpen} isPlayDropdownOpen={isPlayDropdownOpen} setIsPlayDropdownOpen={setIsPlayDropdownOpen} setIsPuzzleDropdownOpen={setIsPuzzleDropdownOpen}  width={width} logged={logged} show={showNav} coin={coin} time={time} selected={selected} scrollPos={scrollPos} scrolledUp={scrolledUp} dark={dark} setDark={setDark} />
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                  <Hero width={width} />
                  <Features width={width} />
                  <Analyse width={width} />
                  <Explore />
                  <ThreatAnalysis width={width} />
                  <Learn />
                  <Review />
                  <Puzzles width={width} />
                  <Footer width={width} />
                </div>
              }
            />
            <Route
              path="/login"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <Login
                dark={dark}
                setShow={setShowNav}
                setSelected={setSelected}
                  setShowAlert={setShowAlert}
                  setAlertType={setAlertType}
                  setAlertText={setAlertText}
                />
                </div>
              }
            />
            <Route
              path="/settings"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <Settings
                width={width}
                dark={dark}
                  setShowAlert={setShowAlert}
                  setAlertType={setAlertType}
                  setAlertText={setAlertText}
                />
                </div>
              }
            />
            <Route
              path="/pricing"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <Pricing
                />
                </div>
              }
            />
            <Route
              path="/contact"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <Contact
                setShowAlert={setShowAlert}
                  setAlertType={setAlertType}
                  setAlertText={setAlertText} 
                /></div>
              }
            />
            <Route
              path="/about"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <About />
                </div>
              }
            />
            <Route
              path="/register"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <Register
                dark={dark}
                  setShow={setShowAlert}
                  setAlertType={setAlertType}
                  setAlertText={setAlertText}
                  lang={1}
                />
                </div>
              }
            />
            <Route
              path="/reset-password"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <ResetPassword
                dark={dark}
                setShow={setShowNav}
                setSelected={setSelected}
                  setShowAlert={setShowAlert}
                  setAlertType={setAlertType}
                  setAlertText={setAlertText}
                  lang={1}
                />
                </div>
              }
            />
            <Route
              path="/confirm"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <ConfirmPhone
                dark={dark}
                  setShowAlert={setShowAlert}
                  setAlertType={setAlertType}
                  setAlertText={setAlertText}
                />
                </div>
              }
            />
            <Route
              path="/privacy"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <PrivacyPolicy />
                </div>
              }
            />
            <Route
              path="/terms"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <TermsOfUse />
                </div>
              }
            />
            <Route
              path="/cookies"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <CookiePolicy />
                </div>
              }
            />
            <Route
              path="/openings"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <Openings />
                </div>
              }
            />
            <Route
              path="/profile"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <UserProfile dark={dark} width={width} />
                </div>
              }
            />
            <Route
              path="*"
              element={
                <div className="w-full bg-[#020714]" onClick={() => {
                  setIsPuzzleDropdownOpen(false);
                  setIsPlayDropdownOpen(false);
                }}>
                <NotFound />
                </div>
              }
            />
          </Routes>
        </BrowserRouter>
        <Alert show={showAlert} type={alertType} val={alertText} />
        <AnimatedModal confetti={true} onClick={async () => {
                     window.location.href = 'https://chessmind.io/confirm?mode=phone';
                    }} body={<>
                      <div className="text-center w-full max-w-md mx-auto">
                        {/* Header with coin icon */}
                        <div className="flex items-center justify-center mb-4">
                          <h2 className="text-2xl font-bold text-black">Welcome To Your Free Trail !</h2>
                        </div>
                        
                        {/* Discount badge */}
                        <div className="bg-gradient-to-r from-red-500 to-red-600 text-white px-4 py-2 rounded-full inline-block mb-4 font-bold text-lg">
                          20% OFF COINS
                        </div>
                        
                        {/* Main message */}
                        <h3 className="text-xl font-semibold text-white mb-3">
                          Boost Your Chess Analysis!
                        </h3>
                        
                        <p className="text-gray-300 text-base mb-4 leading-relaxed">
                          Get <span className="text-yellow-400 font-bold">20% extra coins</span> with any purchase during your 24 hours free trail !
                          Perfect for analysing using any of our engines and unlock the ultimate analysis experience.
                        </p>
                        
                        {/* Urgency message */}
                        <div className="bg-gradient-to-r from-orange-500/20 to-red-500/20 border border-orange-400/30 rounded-lg p-3 mb-4">
                          <p className="text-orange-300 font-medium text-sm">
                            ⚡ <span className="font-bold">Don't miss this chance!</span> Verify your phone number now to get started !
                          </p>
                        </div>
                        
                        {/* Benefits list */}
                        <div className="text-left mb-4">
                          <p className="text-gray-300 text-sm mb-2 font-medium">What you get:</p>
                          <ul className="text-gray-400 text-sm space-y-1">
                            <li className="flex items-center">
                              <span className="text-green-400 mr-2">✓</span>
                              Unlimited Access to our 10MN/s stockfish servers
                            </li>
                            <li className="flex items-center">
                              <span className="text-green-400 mr-2">✓</span>
                              Use coins at any time without expiration
                            </li>
                            <li className="flex items-center">
                              <span className="text-green-400 mr-2">✓</span>
                              20% Extra coins on your first purchase
                            </li>
                          </ul>
                        </div>
                      </div>
                      </>} showButton={true} applyText="Verify Phone" index={11} trigger={<button ref={discountRef} className={`opacity-0 hidden`}></button>} />
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;
